import { TFunction } from 'i18next'

import { DATE_FORMAT } from '@features/vatDeclarations/constants/dateFormat'
import { getDaysPastDeadline } from '@features/vatDeclarations/utils/getDaysPastDeadline'

import { formatDate } from '../../../../../../../utils'
import { VatDeclarationStatus } from '../../../../../enums/vatDeclarationStatus'

interface GetDueDateLabelProps {
  locale?: string
  reportDeadline: string
  status: VatDeclarationStatus
  t: TFunction
}

export const getDueDateLabel = ({ locale, reportDeadline, status, t }: GetDueDateLabelProps) => {
  if (status !== VatDeclarationStatus.OverduePayment && status !== VatDeclarationStatus.OverdueSubmission) {
    return formatDate(reportDeadline, DATE_FORMAT, locale)
  }

  const daysPastDeadline = getDaysPastDeadline(reportDeadline)

  return t('vat_declarations.status_card.overdue_by_days', { days: daysPastDeadline })
}
